<template>
  <v-dialog
    v-model="dialog"
    width="600px"
    :fullscreen="$vuetify.breakpoint.smAndDown"
  >
    <v-card>
      <v-card-title class="amber darken-1 white--text"
        >Thêm học viên mới
        <v-spacer />
        <v-icon color="white" @click="cancel">close</v-icon>
      </v-card-title>
      <v-divider />
      <student-form ref="form" />
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          class="px-4 mr-4 mt-n2 mb-5"
          color="primary"
          @click="save"
          :loading="loading"
          dense
          ><v-icon>mdi-plus</v-icon>Thêm</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import StudentForm from '@/modules/student/StudentForm'
export default {
  components: {
    StudentForm
  },
  props: {
    state: Boolean,
    major: Object,
    course: Object
  },
  data() {
    return {
      dialog: false,
      loading: false
    }
  },
  computed: {
    ...mapState('app', ['roles', 'department']),
    ...mapState('auth', ['user'])
  },
  methods: {
    ...mapActions('students', ['createStudent']),
    async save() {
      const data = this.$refs.form.getData()
      if (data) {
        this.loading = true
        const student = await this.createStudent({
          ...data,
          status: 'active',
          department: this.department.id
        })
        this.$refs.form.reset()
        this.$alert.success('Tạo học sinh thành công!')
        this.loading = false
        this.dialog = false
        this.$emit('done', student)
      }
    },
    cancel() {
      this.$refs.form.reset()
      this.dialog = false
    }
  },

  watch: {
    state(state) {
      this.dialog = true
    }
  }
}
</script>
